export default function smoothLink(headH = 72) {
  const interval = 10;
  const divisor = 8;
  const range = (divisor / 2) + 1;
  const links = document.querySelectorAll('a[href*="#"]');

  for (let link of links) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      let toY;
      let nowY = window.pageYOffset;
      const href = e.target.getAttribute('href');
      const url = location.hostname;
      const btn = href.replace(`https://${url}/`, "") ;
      const target = document.querySelector(btn);
      const targetRect = target.getBoundingClientRect();
      const targetY = targetRect.top + nowY - headH;

      (function doScroll() {
        toY = nowY + Math.round((targetY - nowY) / divisor);
        window.scrollTo(0, toY);
        nowY = toY;

        if (document.body.clientHeight - window.innerHeight < toY) {
          window.scrollTo(0, document.body.clientHeight);
          return;
        }
        if (toY >= targetY + range || toY <= targetY - range) {
          window.setTimeout(doScroll, interval);
        } else {
          window.scrollTo(0, targetY);
        }
      })();
    }, {passive: false});
  }
}

// let headH = document.querySelector('.global-navigation').offsetHeight;
// document.body.style.marginTop = headH + "px";